/**
 * Sticky banner shown across the entire app when the current session is an
 * impersonation issued by the CEO (`localStorage.wc_impersonating === "1"`).
 * Click "Exit" to restore the original CEO token from `wc_ceo_token`.
 */
import React from "react";
import { Eye, X } from "lucide-react";

export default function ImpersonationBanner() {
  const isImpersonating = typeof window !== "undefined" && localStorage.getItem("wc_impersonating") === "1";
  if (!isImpersonating) return null;

  const targetName = localStorage.getItem("wc_impersonating_name") || "user";
  const targetRole = localStorage.getItem("wc_impersonating_role") || "";

  const exit = () => {
    const ceoToken = localStorage.getItem("wc_ceo_token");
    if (ceoToken) {
      localStorage.setItem("wc_token", ceoToken);
    }
    localStorage.removeItem("wc_ceo_token");
    localStorage.removeItem("wc_impersonating");
    localStorage.removeItem("wc_impersonating_name");
    localStorage.removeItem("wc_impersonating_role");
    // Land back on the admin control surface
    window.location.href = "/crece-control-x7q9";
  };

  return (
    <div data-testid="impersonation-banner"
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-center gap-3 shadow-md">
      <Eye className="w-4 h-4" />
      <span className="text-sm font-bold">
        You are acting as <strong>{targetName}</strong>{targetRole ? ` (${targetRole})` : ""} — every action you take applies to their account.
      </span>
      <button onClick={exit} data-testid="impersonation-exit-btn"
        className="ml-3 inline-flex items-center gap-1.5 bg-amber-900 text-amber-50 hover:bg-amber-950 px-3 py-1 rounded-full text-xs font-bold">
        <X className="w-3.5 h-3.5" /> Exit
      </button>
    </div>
  );
}
